import Bar from "./Bar";
import Column from "./Column";
import Donut_gauge from "./Donut_gauge";
import Table from "./Table";
import Pie from "./Pie";
import Line from "./Line";
export default {
    Table: Table,
    Donut_gauge: Donut_gauge,
    Bar: Bar,
    Column: Column,
    Pie: Pie,
    Line: Line
};
